import { useState } from 'react';
import { sendSMS } from '../../apis/sms';

interface fast2SMSConfig {
  senderId: string;
  apiKey: string;
  fast2smsRoute: string;
  message: string;
}

const Fast2SMSConfig = () => {
  const initialConfig = {
    type: 'fast2sms',
    options: {
      senderId: '',
      apiKey: '',
      fast2smsRoute: '',
      message: '',
    },
  };

  const [config, setConfig] = useState<{
    type: string;
    options: fast2SMSConfig;
  }>(initialConfig);

  const handleInputChange = (e: { target: { id: any; value: any } }) => {
    let options: any = config.options;
    options[e.target.id] = e.target.value;
    setConfig({
      type: 'fast2sms',
      options,
    });
  };

  const handleSMSSend = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    sendSMS(config);
  };

  return (
    <div>
      <input
        type='text'
        id='senderId'
        placeholder='Sender Id*'
        required
        onChange={handleInputChange}
      />
      <input
        type='text'
        id='apiKey'
        placeholder='Api Key*'
        required
        onChange={handleInputChange}
      />
      <input
        type='text'
        id='fast2smsRoute'
        placeholder='Fast2SMS Route*'
        required
        onChange={handleInputChange}
      />
      <input
        type='text'
        id='to'
        placeholder='to*'
        required
        onChange={handleInputChange}
      />
      <input
        type='text'
        id='message'
        placeholder='Message*'
        required
        onChange={handleInputChange}
      />
      <button className='submitButton' onClick={handleSMSSend}>Send SMS</button>
    </div>
  );
};

export default Fast2SMSConfig;
